import React from 'react';
import { Section } from '../ui/Section';
import { Building2, Package, Calendar } from 'lucide-react';
export function ImpactCounters() {
  return <Section background="deep-blue" data-id="element-125">
      <div className="text-center mb-12" data-id="element-126">
        <h2 className="text-3xl md:text-4xl font-playfair font-bold mb-4" data-id="element-127">
          Inaugural Mission Progress
        </h2>
        <p className="text-lg font-inter max-w-3xl mx-auto opacity-90" data-id="element-128">
          Every donation brings us closer to our March shipment goal.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-129">
        {[{
        icon: <Building2 size={48} className="text-primary-gold" data-id="element-130" />,
        value: '1',
        label: 'Monastery Partnership',
        description: 'Clinic & dental services established'
      }, {
        icon: <Package size={48} className="text-primary-gold" data-id="element-131" />,
        value: '300+',
        label: 'Medical Units',
        description: 'Collected & catalogued'
      }, {
        icon: <Calendar size={48} className="text-primary-gold" data-id="element-132" />,
        value: 'March',
        label: 'Target',
        description: 'Inaugural shipment'
      }].map((counter, index) => <div key={index} className="text-center" data-id="element-133">
            <div className="flex justify-center mb-4" data-id="element-134">{counter.icon}</div>
            <div className="font-playfair font-bold text-4xl md:text-5xl text-primary-gold mb-2" data-id="element-135">
              {counter.value}
            </div>
            <div className="font-playfair font-bold text-xl mb-2" data-id="element-136">
              {counter.label}
            </div>
            <p className="font-inter text-sm opacity-90" data-id="element-137">
              {counter.description}
            </p>
          </div>)}
      </div>
      <div className="mt-12 max-w-4xl mx-auto text-center" data-id="element-138">
        <p className="text-lg font-inter opacity-90" data-id="element-139">
          Our partnership with our monastery clinic gives us direct access to
          communities with real healthcare needs. Every donation brings us
          closer to delivering 300+ units of medical supplies—including
          essential dental equipment—to practitioners serving both monks and
          surrounding villages.
        </p>
      </div>
    </Section>;
}